module.exports = __webpack_public_path__ + "images/nate-fischer.jpg";